import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login/Login';
import SignUp from './pages/SignUp/SignUp';
import Dashboard from './pages/Dashboard/Dashboard'; // Asegúrate de que el camino sea correcto
import useAuth from './hooks/useAuth';
import UsersList from './views/users/users/UsersList'; // importa vista de usuarios
import UsersCreate from './views/users/users/UsersCreate';
import OriginsList from './views/masters/origins/OriginsList';
import OriginsCreate from './views/masters/origins/OriginsCreate';
import CitiesList from './views/masters/cities/CitiesList';
import CitiesCreate from './views/masters/cities/CitiesCreate';
import NotFound from './pages/NotFound/NotFound';
import ParkingRegisterList from './views/home/parkingRegsiter/ParkingRegister';
import UnderConstruction from './pages/UnderConstruction/UnderConstruction';
import RolesList from './views/users/roles/RolesList'; // importa vista de roles
import RolesCreate from './views/users/roles/RolesCreate'; //  importa vista de creación de roles
import PermissionsList from './views/users/permissions/PermissionsList';
import PermissionsCreate from './views/users/permissions/PermissionsCreate';
import DepartmentsList from './views/masters/departments/DepartmentsList';
import DepartmentsCreate from './views/masters/departments/DepartmentsCreate';
import UserAccessAssignment from './views/users/users/UserAccessAssignment';
import RolePermissionAssignment from './views/users/roles/RolePermissionAssignment';

const PrivateRoute = ({ children }) => {
  const { auth } = useAuth();

  return auth.isAuthenticated ? children : <Navigate to="/login" />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>}>


          {/* <Route index element={<div>Inicio</div>} /> */}
          {/* en el element del index se puede paser un componende de inicio y se puede dejar navegando desde el logo principal */}
          <Route index element={<ParkingRegisterList />} /> 
          <Route path="home" element={<ParkingRegisterList />} />

          <Route path="users-list" element={<UsersList />} />
          <Route path="users-create" element={<UsersCreate />} />
          <Route path="users/roles-list" element={<RolesList />} />
          <Route path="users/roles-create" element={<RolesCreate />} />
          <Route path="users/permissions-list" element={<PermissionsList />} />
          <Route path="users/permissions-create" element={<PermissionsCreate />} />
          <Route path="users/assign-roles/:userId" element={<UserAccessAssignment />} />
          <Route path="users/assign-permissions/:userId" element={<UserAccessAssignment />} />
          <Route path="users/roles/assign-permissions/:roleId" element={<RolePermissionAssignment />} />

          <Route path="masters/origins-list" element={<OriginsList />} />
          <Route path="masters/origins-create" element={<OriginsCreate />} />
          <Route path="masters/cities-list" element={<CitiesList />}/>
          <Route path="masters/cities-create" element={<CitiesCreate />}/>

          <Route path="masters/departments-list" element={<DepartmentsList />} />
          <Route path="masters/departments-create" element={<DepartmentsCreate />} />
          
        
          <Route path="settings/general" element={<UnderConstruction title="Configuración General" />} />
          <Route path="settings/seguridad" element={<UnderConstruction title="Seguridad" />} />
          <Route path="settings/notificaciones" element={<UnderConstruction title="Notificaciones" />} />
          <Route path="*" element={<NotFound />} />

          {/* <Route path="reportes" element={<div>Reportes</div>} />
          <Route path="configuraciones" element={<div>Configuraciones</div>} /> */}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
